import React from 'react';
import { typicalWaitTimeFormatter } from 'utilities/formatters';
import { ReactComponent as TimeLapse } from 'assets/icons/time--lapse.svg';

const WaitingViewer: React.FC<Props> = ({ waittime, title }) => {
  return (
    <div className="waiting-viewer">
      <TimeLapse className="waiting-viewer-clock-icon" />
      <div className="waiting-viewer-title">{title}</div>
      <div className="waiting-viewer-description">
        Typical wait time for this asset owner is{' '}
        {typicalWaitTimeFormatter(waittime)}
      </div>
    </div>
  );
};

type Props = {
  waittime: number;
  title: string;
};

export default React.memo(WaitingViewer);
